import natsort from "natsort";
import { useState } from "react";

function useSort<T>(
  initialOrder: "asc" | "desc" = "desc",
  initialOrderByGetters: ((value: T) => any)[] = [],
  initialOrderBy: string = ""
) {
  //ソート方法
  const [order, setOrder] = useState<"desc" | "asc">(initialOrder);
  //ソート対象
  const [orderBy, setOrderBy] = useState<string>(initialOrderBy);

  const [orderByGetters, setOrderByGetters] = useState<((value: T) => any)[]>(
    initialOrderByGetters
  );

  //ソート対象、方法の変更
  const handleRequestSort = (event: any, property: string) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  const createSortHandler =
    (property: string, getters: ((value: T) => any)[]) => (event: any) => {
      handleRequestSort(event, property);
      setOrderByGetters(getters);
    };
  //ソート実行
  function stableSort(array: T[], comparator: (a: T, b: T) => number): T[] {
    const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el: any) => el[0]);
  }

  function getComparator(
    order: "asc" | "desc",
    getters: ((value: T) => any)[]
  ) {
    return (a: T, b: T): number => {
      for (const getter of getters) {
        const valueA = getter(a);
        const valueB = getter(b);
        return order === "asc"
          ? natsort()(valueA, valueB)
          : -natsort()(valueA, valueB);
      }
      return 0;
    };
  }

  return {
    order,
    orderBy,
    createSortHandler,
    stableSort,
    getComparator,
    orderByGetters,
  };
}
export default useSort;
